import { useContext, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import PropTypes from "prop-types";
import LoginMd from "./LoginMd";
import { RegisterMd } from "./RegisterMd";

import { useHistory } from "react-router-dom";
import StateContext from "../StateContext";
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  textCenter: {
    textAlign: "center",
    justifyContent: "center",
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <div>{children}</div>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function AuthTabs(props) {
  const appState = useContext(StateContext);
  const classes = useStyles();
  const history = useHistory();
  const [value, setValue] = useState(0);

  const handleChange = (ev, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <div className="MainDashboardTabs">
        <AppBar position="static">
          <Tabs
            value={value}
            onChange={handleChange}
            className={classes.textCenter}
            aria-label="simple tabs example"
          >
            <Tab label="Login" className="tabs" {...a11yProps(0)} />
            <Tab label="Register" className="tabs" {...a11yProps(1)} />

            {/* <Tab label="Profile" {...a11yProps(2)} />
                            <Tab label="Order" {...a11yProps(3)} /> */}
          </Tabs>

          <TabPanel value={value} index={0}>
            <LoginMd setAlertMessage={props.setAlertMessage} />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <RegisterMd setAlertMessage={props.setAlertMessage} />
          </TabPanel>
        </AppBar>
      </div>
    </div>
  );
}
